import React from 'react';
import { format } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Calendar } from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { cn } from '../lib/utils';

/**
 * DatePicker — DD-MM-YYYY India locale
 *
 * Props:
 * - value: ISO string "YYYY-MM-DD" or empty
 * - onChange: (isoString) => void
 * - minDate: optional Date
 * - placeholder: optional string
 * - testId: optional data-testid
 */
export const DatePicker = ({ value, onChange, minDate, placeholder = 'Select date', testId }) => {
  const selected = value ? new Date(value + 'T00:00:00') : undefined;

  const handleSelect = (date) => {
    if (!date) {
      onChange('');
      return;
    }
    const iso = format(date, 'yyyy-MM-dd');
    onChange(iso);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className={cn(
            'w-full flex items-center gap-2 border-0 p-0 h-auto text-base font-semibold text-left bg-transparent focus:outline-none',
            !selected && 'text-slate-400'
          )}
        >
          <CalendarIcon className="h-4 w-4 text-[#FF0059]" />
          {selected ? format(selected, 'dd-MM-yyyy') : placeholder}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={handleSelect}
          disabled={(date) => (minDate ? date < new Date(minDate.toDateString()) : false)}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};
